<!-- <a click="refreshData()">Refresh</a> -->
<ag-grid-angular #grid class="data-grid " [rowData]="data" [gridOptions]="gridOptions"  [attr.aria-label]="gridAriaLabel">
</ag-grid-angular>